<div class="log-modal-container">
  <span class="font-12 weight-700 color-secundary">Logs</span>

  <div class="flex-direction-column gap-15 padding-15px overflow">
    @for (log of logs; track log.id) {
      <div class="card-log">
        <div class="flex-row justify-between">
          <div class="flex-row center-center gap-5">
            <div class="area-tipo">
              <img [src]="getSrcTipoLog(log)" alt="{{ log.tipo }}" />
            </div>
            <span class="font-12 weight-700 color-primary">{{ log.tipo }}</span>
          </div>
          <div class="flex-row center-center gap-5">
            <img [matTooltip]="log.usuario.nome" class="img-usuario" [src]="getSrcImgUsuario(log)" alt="{{ log.usuario.nome }}" />
            <span class="font-10 weight-400 color-secundary" style="width: 60px; text-align: end;">{{ log.data | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
          </div>
        </div>

        <div class="divider-log"></div>

        <span class="font-12 weight-400 color-secundary">{{ log.obs }}</span>
      </div>
    }
  </div>
</div>
